import React from "react";
import ReactDOM from "react-dom";
import MyIcon from "../../../images/icon-loading.png";
import "./CustomSpinner.css";

const CustomSpinner = () => {
  return ReactDOM.createPortal(
    <div className="spinner-container" data-testid="spinner-container">
      <div className="custom-spinner" data-testid="custom-spinner">
        <img
          src={MyIcon}
          alt="Loading Icon"
          className="spinning-icon"
          data-testid="my-icon"
        />
      </div>
    </div>,
    document.body
  );
};

export default CustomSpinner;
